/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./issuance.defs.js";
export { main as default } from "./issuance.defs.js";
